// extracted by mini-css-extract-plugin
export default {"container":"OTPInput_container__HunvW","container0":"OTPInput_container0__CeyG4","resend":"OTPInput_resend__cA+FJ","button":"OTPInput_button__kXDho"};